// src/components/Expenses/ExpensesList.js
import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Chip,
  Typography,
  IconButton,
} from "@mui/material";

import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

const getStatusColor = (status) => {
  switch (status) {
    case "draft":
      return "warning";
    case "closed":
      return "error";
    default:
      return "success";
  }
};

const ExpensesList = ({ rows, onRowClick, onDelete }) => {
  const columns = [
    {
      field: "DocumentNumber",
      headerName: "Documento",
      width: 130,
    },
    {
      field: "user",
      headerName: "Solicitante",
      width: 200,
      renderCell: (params) =>
        params.row?.User
          ? params.row.User.username || params.row.User.email
          : "—",
    },
    {
      field: "Status",
      headerName: "Estado",
      width: 100,
      renderCell: (params) => (
        <Chip
          label={params.value}
          color={getStatusColor(params.value)}
          size="small"
        />
      ),
    },
    {
      field: "Contabilizado",
      headerName: "Contabilidad",
      width: 250,
      renderCell: (params) => {
        const contabilizado = params.row.Contabilizado;
        const asiento = params.row.NumeroAsiento;

        return (
          <Box
            sx={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center", // 👈 centra vertical
            }}
          >
            {!contabilizado ? (
              <Typography variant="body2" color="text.secondary">
                No contabilizado
              </Typography>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 1,
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontWeight: "bold", color: "success.main" }}
                >
                  📘 Contabilizado
                </Typography>
                {asiento && (
                  <Typography variant="caption" color="text.secondary">
                    Asiento: {asiento}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        );
      },
    },

    {
      field: "createdAt",
      headerName: "Fecha",
      width: 160,
      renderCell: (params) => {
        if (!params.value) return "—";
        const d = new Date(params.value);
        return isNaN(d.getTime()) ? "—" : d.toLocaleDateString("es-ES");
      },
    },

    {
      field: "totalAdvances",
      headerName: "Anticipos €",
      width: 120,
      align: "right",
      headerAlign: "right",
      renderCell: (params) => `${Number(params.value || 0).toFixed(2)} €`,
    },
    {
      field: "totalExpenses",
      headerName: "Total €",
      width: 120,
      align: "right",
      headerAlign: "right",
      renderCell: (params) => `${Number(params.value || 0).toFixed(2)} €`,
    },
    {
      field: "actions",
      headerName: "",
      sortable: false,
      renderCell: (params) => {
        const row = params.row;

        const canDelete =
          row.Status === "draft" &&
          !row.Contabilizado &&
          Number(row.totalExpenses || 0) === 0;

        if (!canDelete) return null;

        return (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onDelete(row);
            }}
            sx={{
              height: 30,
              width: 30,
              border: "1px solid #ff0000",
              color: "#ff0000",
              "&:hover": { backgroundColor: "#ff0000", color: "#fff" },
            }}
          >
            <DeleteOutlineOutlinedIcon />
          </IconButton>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "calc(100vh - 64px)", width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.id}
        onRowClick={(params) => onRowClick(params.row)}
        disableRowSelectionOnClick
      />
    </Box>
  );
};

export default ExpensesList;
